/**
 * Defer loading of some images.
 */
function loadSwatchImages() {
  var $swatch_images = $('.rsas-swatch-list [data-defer]');

  $swatch_images.each(function(index) {
    $(this).css('background-image', $(this).data('defer'));
  });
}

function loadMegamenuImages() {
  var $megamenu_images = $('.rsas-megamenu [data-defer]');

  $megamenu_images.each(function(index) {
    $(this).attr('src', $(this).data('defer'));
  });
}

$(function() {
  loadSwatchImages();
});

$(window).load(function() {
  loadMegamenuImages();
});


/**
 * If a variant from a linked product is selected,
 * we select the options after the page loads.
 */
function selectUnlimitedVariantOptions() {

  // Get the `variant` query parameter, selected variant data, and product data
  var variant_parameter = (new URL(document.location)).searchParams.get('variant');
  var selected_variant_data = $('[data-selected-variant-json]').html();
  var product_data = $('[data-product-json]').html();

  // Do not continue if there's no variant parameter, selected variant data, or product data
  if (!variant_parameter || !selected_variant_data || !product_data) {
    return;
  }

  // Get the selected variant
  var selected_variant = JSON.parse(selected_variant_data);

  // Do not continue if there is a selected variant
  if (selected_variant) {
    return;
  }

  // Find the variant to select
  var variants = JSON.parse(product_data).variants;
  var variant_to_select = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].id == variant_parameter) {
      variant_to_select = variants[i];
    }
  }

  // Select the options for the variant specified in the query parameter
  if (variant_to_select) {
    for (var i = 0; i < variant_to_select.options.length; i++) {
      var option = $('[data-option-position="' + (i + 1) + '"]');
      var option_type = option.data('option-type');

      if (option_type == 'radio') {

        // Radio button options (like color swatches)
        option.find('.rsas-swatch[data-color="' + variant_to_select.options[i] + '"] label').click();

      } else {

        // Normal select field options
        option.find('select').val(variant_to_select.options[i]).change();

      }
    }
  }

}


$(function () {

  /**
   * Message carousel configuration.
   */
  $('.rsas-carousel-standard').slick({
    arrows: false,
    autoplay: true,
    dots: true
  });

  /**
   * Collection carousel configuration.
   */
  $('.rsas-carousel-center').slick({
    centerMode: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /**
   * Location photo carousel configuration.
   */
  $('.rsas-carousel-locations').slick({
    adaptiveHeight: true,
    arrows: false,
    autoplay: true
  });

  /**
   * Show/hide meganav on over/out.
   */
  if ($(window).width() >= 750) {
    $('.site-nav--has-submenu').hoverIntent({
      over: function() {
        $(this).addClass('site-nav--show-submenu');
      },
      out: function() {
        $(this).removeClass('site-nav--show-submenu');
      },
      timeout: 500
    });
  }

  /**
   * Show/hide toggleable nav on click.
   */
  $('#toggle-mobile-nav').click(function(event) {
    event.preventDefault();

    if (!$('.rsas-toggleable-nav').hasClass('visible')) {
      $('.rsas-toggleable-nav').addClass('visible');
      $('.rsas-toggleable-search').removeClass('visible');
    } else {
      $('.rsas-toggleable-nav').removeClass('visible');
    }
  });

  /**
   * Show/hide toggleable search on click.
   */
  $('#toggle-mobile-search').click(function(event) {
    event.preventDefault();

    if (!$('.rsas-toggleable-search').hasClass('visible')) {
      $('.rsas-toggleable-search').addClass('visible');
      $('.rsas-toggleable-nav').removeClass('visible');
    } else {
      $('.rsas-toggleable-search').removeClass('visible');
    }
  });

  /**
   * Update selected swatch on color selector change.
   */
  $('[data-single-option-selector-color]').change(function(event) {
    var selected_color = $(this).val();

    $('.rsas-swatch').each(function() {
      if ($(this).data('color') == selected_color) {
        $(this).addClass('rsas-swatch-active');
      } else {
        $(this).removeClass('rsas-swatch-active');
      }
    });
  });

  /**
   * Update color selector and selected swatch on swatch click.
   */
  $('.rsas-swatch label').click(function(event) {
    var swatch = $(event.target).closest('.rsas-swatch');

    if (swatch.hasClass('rsas-swatch-not-available')) {
      event.preventDefault();
      return;
    }

    $('[data-single-option-selector-color]').val(swatch.data('color')).change();
    $('.rsas-swatch').removeClass('rsas-swatch-active');
    swatch.addClass('rsas-swatch-active');
  });

  /**
   * Select unlimited variant options on load if necessary.
   */
  selectUnlimitedVariantOptions();

});


/*================ RSAS =================*/
/**
 * Load and parse the cart data, if it exists.
 */
function initializeCartJS() {
  var cart_data = $('[data-cart-json]').html();

  if (!cart_data) {
    return;
  }

  CartJS.init(JSON.parse(cart_data));
}

$(function() {

  /**
   * Initialize CartJS on load.
   */
  initializeCartJS();

  /**
   * Update the cart count when the cart requests are complete.
   */
  $(document).on('cart.requestComplete', function(event, cart) {
    $('[data-cart-count]').text(cart.item_count);
    $('[data-added-to-cart]').fadeIn('slow', function() {
      $(this).delay(2000).fadeOut('slow');
    });
  });

  /**
   * Add 'Multiple Quantity' variants to cart on click.
   */
  $('[data-add-to-cart-mq]').click(function(event) {
    event.preventDefault();

    var variants = $('#mq-variants [data-variant]');

    var variant, quantity;
    for (var i = 0; i < variants.length; i++) {
      variant = $(variants[i]).data('variant-id');
      quantity = parseInt($(variants[i]).find('[data-variant-quantity] input').val());

      if (quantity > 0) {
        CartJS.addItem(variant, quantity);
      }
    }
  });

  /**
   * Add standard variants to cart on click.
   */
  $('[data-add-to-cart]').click(function(event) {
    event.preventDefault();

    var variant = $('[data-product-select]').val();
    var quantity = parseInt($('#Quantity').val());

    if (quantity > 0) {
      if ($('#skt_cgc_lineitems').length) {
        CartJS.addItem(variant, quantity, {
          'To': $('#sktcgc_to').val(),
          '_From': $('#sktcgc_from').val(),
          '_Msg': $('#sktcgc_msg').val()
        });
      } else {
        CartJS.addItem(variant, quantity);
      }
    }
  });

});

// (c) Copyright 2016 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus

var Shopify = Shopify || {};

Shopify.uniq = function(e) {
  for (var t = [], n = 0; n < e.length; n++) {
    Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
  }
  return t;
};

Shopify.arrayIncludes = function(e, t) {
  for (var n = 0; n < e.length; n++) {
    if (e[n] == t) {
      return !0;
    }
  }
  return !1;
};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function(selectorIndex) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery('#SingleOptionSelector-0');
      break;
    case 1:
      var key = jQuery('#SingleOptionSelector-0').val();
      var selector = jQuery('#SingleOptionSelector-1');
      break;
    case 2:
      var key = jQuery('#SingleOptionSelector-0').val();
      key += ' / ' + jQuery('#SingleOptionSelector-1').val();
      var selector = jQuery('#SingleOptionSelector-2');
  }

  var initialValue = selector.val();
  selector.empty();
  var availableOptions = Shopify.optionsMap[key];
  for (var i=0; i<availableOptions.length; i++) {
    var option = availableOptions[i];
    var newOption = jQuery('<option></option>').val(option).html(option);
    selector.append(newOption);
  }
  jQuery('.rsas-swatch-list[data-option-index="' + selectorIndex + '"] .rsas-swatch').each(function() {
    if (jQuery.inArray($(this).attr('data-color'), availableOptions) !== -1) {
      $(this)
        .removeClass('rsas-swatch-not-available')
        .find(':radio')
        .removeAttr('checked')
        .removeAttr('disabled', 'disabled');
    } else {
      $(this)
        .addClass('rsas-swatch-not-available')
        .find(':radio')
        .removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');

};

Shopify.linkOptionSelectors = function(product) {
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  jQuery("#SingleOptionSelector-0").change(function() {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery("#SingleOptionSelector-1").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

if ($('[data-product-json]').length) {
  var linkedOptionsProduct = JSON.parse($('[data-product-json]').html());

  if (linkedOptionsProduct.available && linkedOptionsProduct.options.length > 1) {
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver && $addToCartForm.length) {
      if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
      var config = { childList: true, subtree: true };
      var observer = new MutationObserver(function() {
        Shopify.linkOptionSelectors(linkedOptionsProduct);
        observer.disconnect();
      });
      observer.observe($addToCartForm[0], config);
    }
  }
}

$(function() {

  /**
   * Normalize the height of all location descriptions.
   */

  var did_resize = false;

  updateHeights();

  $(window).resize(function() {
    did_resize = true;
  });

  setInterval(function() {
    if (did_resize) {
      did_resize = false;
      updateHeights();
    }
  }, 250);

  function updateHeights() {
    if ($(window).width() > 750) {
      var maxHeight = 0;

      $('.rsas-location-info').each(function() {
        var currentHeight = $(this).height();

        if (currentHeight > maxHeight) {
          maxHeight = currentHeight;
        }
      });

      $('.rsas-location-info').css('height', maxHeight);
    } else {
      $('.rsas-location-info').css('height', '');
    }
  }

});

/**
 * Product Images Carousel and Lightbox
 */


/**
 * updateSelectedImage
 * ----
 * Update the featured product image and
 * the active product image thumbnail.
 */

function updateSelectedImage(id) {
  var thumbnail_images = JSON.parse($('[data-product-images-json]').html());
  var selected_image = thumbnail_images[id];
  var elem = $('[data-featured-image-obj] img');

  elem.attr('src', selected_image.src);
  elem.attr('alt', selected_image.alt);
  elem.attr('width', selected_image.width);
  elem.attr('height', selected_image.height);
  elem.data('position', selected_image.position);

  $('.rsas-thumbnail-carousel .rsas-thumbnail').each(function(index) {
    if ($(this).data('id') == selected_image.id) {
      $(this).addClass('rsas-thumbnail--active');
    } else {
      $(this).removeClass('rsas-thumbnail--active');
    }
  });
}


$(function() {

  /**
   * Display lightbox on featured product image click.
   */

  $('[data-featured-image-obj] a').click(function(event) {
    event.preventDefault();

    var lightbox_images = JSON.parse($('[data-product-lightbox-images-json]').html());
    var elem = $(event.target);

    $.fancybox(lightbox_images, {
      'padding'     : 0,
      'width'       : elem.attr('width'),
      'height'      : elem.attr('height'),
      'index'       : elem.data('position') - 1,
      'openEffect'  : 'none',
      'closeEffect' : 'none',
      'nextEffect'  : 'fade',
      'prevEffect'  : 'fade',
      'openSpeed'   : 'fast',
      'closeSpeed'  : 'fast',
      'openEasing'  : 'swing',
      'closeEasing' : 'swing'
    });
  });


  /**
   * Thumbnail carousel initialization.
   */

  $('.rsas-thumbnail-carousel').slick({
    dots: false,
    infinite: true,
    lazyLoad: 'ondemand',
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });


  /**
   * Update selected image on thumbnail click.
   */

  $('.rsas-thumbnail-carousel a').click(function(event) {
    event.preventDefault();
    updateSelectedImage($(this).closest('.rsas-thumbnail').data('id'));
  });

});

$(function() {

  /**
   * Basic tab behavior.
   */

  $('[data-rsas-tab] a').click(function(event) {
    event.preventDefault();

    var target_id = $(this).closest('[data-rsas-tab]').data('rsas-tab');
    var tab_container = $(this).closest('.rsas-tabs');
    var pane_container = $('[data-rsas-tab-pane=' + target_id + ']').closest('.rsas-tab-panes');

    tab_container.find('.rsas-tab').each(function() {
      if ($(this).data('rsas-tab') == target_id) {
        $(this).addClass('rsas-active');
      } else {
        $(this).removeClass('rsas-active');
      }
    });

    pane_container.find('.rsas-tab-pane').each(function() {
      if ($(this).data('rsas-tab-pane') == target_id) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

});

$(function() {

  /**
   * Validate contact form.
   */

  $('#contact_form').validate({
    errorClass: 'rsas-error'
  });

});
